import React, { useEffect, useState } from "react";
import {
	TabContent,
	TabPane,
	Nav,
	NavItem,
	NavLink,
	Col,
	Button,
} from "reactstrap";
import classnames from "classnames";
import withRouter from "../../../../components/Common/withRouter";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import DadosAta from "./dados/Dados";
import DefinicoesAta from "./definicoes/Definicoes";
import Encaminhamentos from "./Encaminhamentos";
import ataService from "services/AtaService";
import permissionsService from "services/permissionsService";
import Loading from "components/Common/Loading";
import authUserRoleService from "services/AuthUserRoleService";
import { Link } from "react-router-dom";
import { ArrowLeft, Funnel, Plus } from "@phosphor-icons/react";

const NavbarAta = (props) => {
	const params = props.router.params;
	const id = params?.id;

	const [activeTab, setActiveTab] = useState("encaminhamentos");
	const [podeVisualizar, setPodeVisualizar] = useState(false);
	const [permissions, setPermissions] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [ata, setAta] = useState({});
	const [apenasVisualizaEImprime, setApenasVisualizaEImprime] =
		useState(false);

	const toggle = (tab) => {
		if (activeTab !== tab) setActiveTab(tab);
	};

	const getAta = async () => {
		const response = await ataService.getById(id);
		setAta(response);
		return response;
	};

	const getPermissions = async () => {
		const response = await permissionsService.getPermissions();
		setPermissions(response);
	};

	const getAll = async () => {
		setIsLoading(true);
		const ata = await getAta();
		if (Number(ata.consultants_only) === 1) {
			const user = await localStorage.getItem("authUser");
			const user_parse = JSON.parse(user);
			const auth_user =
				await authUserRoleService.getUserPermissionGroup();
			if (!auth_user) {
				setPodeVisualizar(false);
			} else {
				setPodeVisualizar(true);
			}
		} else {
			setPodeVisualizar(true);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		if (id) {
			getAll();
		}
	}, [id]);

	return (
		<Loading isLoading={isLoading}>
			<div className="page-content">
				{id && (
					<div
						className="container-fluid"
						style={{
							backgroundColor: "white",
							padding: 20,
							borderRadius: 10,
						}}
					>
						<Col
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "flex-start",
								marginBottom: 20,
								gap: 8,
							}}
						>
							<div
								style={{
									display: "flex",
									alignItems: "center",
									gap: "8px",
									cursor: "pointer",
								}}
								onClick={() => window.history.back()}
							>
								<ArrowLeft
									size={20}
									style={{
										color: "black",
									}}
								/>
								<h4
									style={{
										fontSize: "18px",
										fontWeight: "bold",
										margin: 0,
									}}
								>
									{ata ? ata.name : ""}
								</h4>
							</div>
						</Col>

						<Nav tabs>
							<NavItem>
								<NavLink
									className={classnames({
										active: activeTab === "encaminhamentos",
									})}
									onClick={() => {
										toggle("encaminhamentos");
									}}
									style={{
										cursor: "pointer",
										color:
											activeTab === "encaminhamentos"
												? "#2a3042"
												: "inherit",
									}}
									onMouseEnter={(e) =>
										(e.target.style.color = "#2a3042")
									}
									onMouseLeave={(e) =>
									(e.target.style.color =
										activeTab === "encaminhamentos"
											? "#2a3042"
											: "inherit")
									}
								>
									Encaminhamentos
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink
									className={classnames({
										active: activeTab === "definicoes",
									})}
									onClick={() => {
										toggle("definicoes");
									}}
									style={{
										cursor: "pointer",
										color:
											activeTab === "definicoes"
												? "#2a3042"
												: "inherit",
									}}
									onMouseEnter={(e) =>
										(e.target.style.color = "#2a3042")
									}
									onMouseLeave={(e) =>
									(e.target.style.color =
										activeTab === "definicoes"
											? "#2a3042"
											: "inherit")
									}
								>
									Definições
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink
									className={classnames({
										active: activeTab === "dados",
									})}
									onClick={() => {
										toggle("dados");
									}}
									style={{
										cursor: "pointer",
										color:
											activeTab === "dados"
												? "#2a3042"
												: "inherit",
									}}
									onMouseEnter={(e) =>
										(e.target.style.color = "#2a3042")
									}
									onMouseLeave={(e) =>
									(e.target.style.color =
										activeTab === "dados"
											? "#2a3042"
											: "inherit")
									}
								>
									Dados
								</NavLink>
							</NavItem>
						</Nav>
						<TabContent
							activeTab={activeTab}
							style={{
								backgroundColor: "white",
								borderRadius: 10,
								marginTop: 5,
							}}
						>
							<TabPane tabId="encaminhamentos">
								<Encaminhamentos
									dataId={id}
									podeVisualizar={podeVisualizar}
								/>
							</TabPane>
							<TabPane tabId="definicoes">
								<DefinicoesAta
									dataId={id}
									podeVisualizar={podeVisualizar}
								/>
							</TabPane>
							<TabPane tabId="dados">
								<DadosAta
									dataId={id}
									podeVisualizar={podeVisualizar}
									onNavigateToTab={(tab) => setActiveTab(tab)}
								/>
							</TabPane>
						</TabContent>
					</div>
				)}
			</div>
		</Loading>
	);
};

export default withRouter(NavbarAta);
